import { Card, Row, Col, Empty } from "antd";
import { Pie } from "react-chartjs-2";

import React from "react";

const CallsGraphs: React.FC<{chartData: any}> = ({ chartData }) => {
  const options: any = {
    maintainAspectRatio: false,
    responsive: true,
    radius: "100%",
    layout: {
      padding: {
        top: 10,
      },
    },
    plugins: {
      legend: {
        display: true,
        position: "bottom",
        align: "center",
        labels: {
          usePointStyle: true,
          padding: 10,
          font: {
            size: 10,
            family: "'Inter', sans-serif",
          },
          color: "#667085",
        },
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (context: any) => `${context.label}: ${context.raw}%`,
        },
      },
    },
  };

  return (
    <Row gutter={40} className="mt-4" style={{ textAlign: "center" }}>
      <Col span={12}>
        <Card
          title="Topic Duration Distribution"
          bodyStyle={{ padding: "12px", height: "350px" }}
        >
          {chartData && chartData.topicData.datasets[0].data.length > 0 ? (
            <div style={{ position: "relative", height: "300px", width: "100%" }}>
              <Pie data={chartData.topicData} options={options} />
            </div>
          ) : (
            <Empty description="No Data Available" />
          )}
        </Card>
      </Col>

      <Col span={12}>
        <Card
          title="Emotion Duration Distribution"
          bodyStyle={{ padding: "12px", height: "350px" }}
        >
          {chartData && chartData.emotionData.datasets[0].data.length > 0 ? (
            <div style={{ position: "relative", height: "300px", width: "100%" }}>
              <Pie data={chartData.emotionData} options={options} />
            </div>
          ) : (
            <Empty description="No Data Available" />
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default CallsGraphs;